// import each language file
import ar from './languages/ar.json';
import de from './languages/de.json';
import en from './languages/en.json';
import fr from './languages/fr.json';
import it from './languages/it.json';
import pl from './languages/pl.json';
import ru from './languages/ru.json';
import tr from './languages/tr.json';
import uk from './languages/uk.json';

// special terms for thoughts by using custom "dialects" currently only in german
// to discuss whether we also want to translate the "dialects"
import de_custom_dialects from './dialects/de-thought.json';

const messages = {
  ar: {
    ...ar,
  },
  de: {
    ...de,
  },
  de_custom_dialects,
  en: {
    ...en,
  },
  fr: {
    ...fr,
  },
  it: {
    ...it,
  },
  pl: {
    ...pl,
  },
  ru: {
    ...ru,
  },
  tr: {
    ...tr,
  },
  uk: {
    ...uk,
  },
};
// console.log(messages);

// add all imported language files
export { messages };

// FS doesn't work unfortunately... (reading all folders/files from filesystem)
// also importing via promises makes problems (to have array of folders/filenames here and load everything dynamically)
